import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SelectLassoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M3.98582 5.3116C4.70192 4.6798 5.51262 4.133 6.38372 3.6823C6.75692 3.4905 6.90882 3.0383 6.70762 2.6707C6.52862 2.3089 6.08622 2.1491 5.72712 2.3333C4.71832 2.8506 3.78332 3.4828 2.95932 4.2173C2.65812 4.4857 2.65132 4.9569 2.92552 5.2529C3.19732 5.5722 3.67182 5.5903 3.98582 5.3116Z"
        fill={color}
      />
      <path
        d="M1.74319 10.2578C1.73559 9.31042 1.93859 8.36692 2.32959 7.48702C2.48759 7.13152 2.31899 6.71552 1.96799 6.54802C1.58239 6.34522 1.11439 6.52522 0.939486 6.92472C0.477086 7.97382 0.235886 9.08942 0.242186 10.2184C0.244486 10.6449 0.584486 10.9925 1.01059 10.9747C1.40789 10.9742 1.74729 10.6564 1.74319 10.2578Z"
        fill={color}
      />
      <path
        d="M14.9546 2.63486C15.9197 2.84766 16.8604 3.15536 17.7462 3.55366C18.1269 3.72586 18.5735 3.56516 18.7375 3.18136C18.9106 2.81486 18.7601 2.36636 18.3909 2.19906C17.3952 1.74786 16.337 1.40096 15.2504 1.16416C14.8543 1.07786 14.4646 1.34556 14.3836 1.74276C14.285 2.14826 14.5464 2.54586 14.9546 2.63486Z"
        fill={color}
      />
      <path
        d="M23.0491 9.34028C22.6547 9.30978 22.2957 9.58978 22.2517 9.98288C22.1473 10.9152 21.8436 11.8227 21.37 12.6609C21.1741 13.0076 21.303 13.4479 21.6444 13.6528C22.0149 13.8753 22.4871 13.7341 22.6985 13.3571C23.2538 12.3672 23.6108 11.2984 23.7373 10.1977C23.7869 9.76598 23.4823 9.37378 23.0491 9.34028Z"
        fill={color}
      />
      <path
        d="M21.7869 7.40981C21.9659 7.78501 22.4074 7.94031 22.7698 7.74251C23.1564 7.56971 23.3092 7.11101 23.1241 6.73011C22.6326 5.71851 21.9475 4.79601 21.1101 3.99661C20.8256 3.72511 20.3673 3.75681 20.1007 4.04591C19.7921 4.33661 19.8013 4.81951 20.1086 5.11461C20.8042 5.78941 21.3767 6.56311 21.7869 7.40981Z"
        fill={color}
      />
      <path
        d="M19.5174 14.7197C18.7549 15.3022 17.9078 15.7987 17.0089 16.1989C16.6268 16.3679 16.4486 16.8082 16.6257 17.1862C16.784 17.5593 17.22 17.7452 17.5908 17.5815C18.6212 17.1265 19.5889 16.5586 20.4589 15.8886C20.7891 15.6353 20.8211 15.1438 20.5501 14.8295C20.2958 14.5115 19.8411 14.4725 19.5174 14.7197Z"
        fill={color}
      />
      <path
        d="M14.2246 17.0172C13.2525 17.1759 12.2579 17.2476 11.2715 17.2286C10.854 17.2195 10.5078 17.5457 10.5087 17.9628C10.4944 18.3681 10.8105 18.719 11.2159 18.7277C12.3104 18.7511 13.4139 18.6711 14.492 18.493C14.9027 18.426 15.1667 18.0136 15.0788 17.6079C15.0073 17.2074 14.6261 16.9516 14.2246 17.0172Z"
        fill={color}
      />
      <path
        d="M9.1161 2.7209C10.0794 2.5144 11.0697 2.3954 12.0571 2.3665C12.4637 2.3547 12.7893 2.0315 12.7837 1.6247C12.7932 1.2096 12.4558 0.854602 12.0397 0.866502C10.9429 0.895802 9.8441 1.0279 8.7751 1.2599C8.3789 1.3458 8.1359 1.7504 8.2271 2.1454C8.3055 2.5552 8.7079 2.8095 9.1161 2.7209Z"
        fill={color}
      />
      <path
        d="M4.38923 13.291C3.93572 13.291 3.50822 13.3953 3.12002 13.5721C2.90952 13.2886 2.69742 12.9943 2.51582 12.7227C2.29002 12.3819 1.82992 12.3014 1.49212 12.5263C1.12922 12.7361 1.01732 13.2044 1.23842 13.5605C1.44692 13.8963 1.69242 14.2127 1.93572 14.5284C1.54672 15.0443 1.30722 15.6787 1.30722 16.3731C1.30722 18.0723 2.69002 19.4551 4.38923 19.4551C5.55183 19.4551 6.55403 18.8002 7.07882 17.8471C8.30723 19.3205 8.73662 21.3102 7.97132 22.6221C7.76283 22.9805 7.88342 23.4395 8.24132 23.6475C8.36042 23.7168 8.49032 23.75 8.61872 23.75C8.87652 23.75 9.12753 23.6172 9.26713 23.3779C10.5143 21.2386 9.68223 18.0439 7.44222 16.0862C7.29492 14.523 5.99022 13.291 4.38923 13.291ZM4.38923 17.9551C3.51662 17.9551 2.80722 17.2451 2.80722 16.3731C2.80722 15.5011 3.51673 14.7911 4.38923 14.7911C5.26172 14.7911 5.97122 15.5011 5.97122 16.3731C5.97122 17.2451 5.26172 17.9551 4.38923 17.9551Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SelectLassoIcon.displayName = 'SelectLassoIcon';
